import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Row, Col, Radio, Typography } from 'antd';
import { OnlineInventoryAPI } from '../../api/onlineInventoryAPI';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { UploadWithTable, useCustomToast } from '../../../../components';

const { Text } = Typography;

interface PhysicalVerificationProps {
  visible: boolean;
  onClose: () => void;
  record: any;
  refetch?: () => void;
}

const PhysicalVerification: React.FC<PhysicalVerificationProps> = ({ visible, onClose, record, refetch }) => {
  const { showToast } = useCustomToast();
  const [form] = Form.useForm();
  const [files, setFiles] = useState<[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
      if (!visible || isLoading || !!record?.selectedRowKeys) return;
      if (record.inventory_status === 'Por verificar') return;
      
      setIsLoading(true);
      OnlineInventoryAPI.showVerification(record.inventory_id, record.id)
        .then(response => {
          setIsEditable(response.documents?.length);
          form.setFieldsValue({
            check: response?.is_checked ? '1' : '0',
          });

          setFiles(response?.documents || []);
        })
        .catch(error => {
          setIsEditable(false);
          showToast(
            'error',
            error?.response?.data?.message || 'Error al obtener los detalles del activo'
          );
        })
        .finally(() => setIsLoading(false));
    }, [visible, record]);


  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const formData = new FormData();
      formData.append('inventory_id', record.inventory_id);
      formData.append('is_checked', values.check);
      files.forEach((file: any) => {
        formData.append('files[]', file.file);
      });

      const response = await OnlineInventoryAPI.toggleAssetCheck(record.id, formData);
      showToast('success', response?.message || "Verificación actualizada correctamente");
      refetch && refetch();
      
      onClose();
      setIsEditable(false);
    } catch (error: any) {
      
      showToast('error',
        error?.response?.data?.message ||
        'Error al actualizar la ubicación'
      );
    }
  };


  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={600}>
      <Form layout="vertical" form={form}>
        <Row justify="center" style={{ marginBottom: 20 }}>
          <Col>
            <ExclamationCircleOutlined style={{ fontSize: 50, color: '#faad14' }} />
          </Col>
        </Row>

        <Row justify="center" style={{ textAlign: 'center', marginBottom: 20 }}>
          <Col>
            <Text strong>¿Desea realizar verificación física?</Text>
          </Col>
        </Row>

        <Row justify="center">
          <Col>
            <Form.Item name="check" rules={[{ required: true, message: 'Seleccione una opción' }]}>
              <Radio.Group disabled={isEditable}>
                <Radio value="1">Sí</Radio>
                <Radio value="0">No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Col xs={24}>
            <UploadWithTable
              onFilesChange={setFiles}
              files={files}
              disabled={isEditable}
              downloadFiles={isEditable}
            />
          </Col>
        </Row>

        <Row justify="end" gutter={16}>
          <Col><Button onClick={onClose}>Cerrar</Button></Col>
          <Col>
            {!isEditable ?
              <Button type="primary" onClick={handleSubmit}>
                Aceptar
              </Button> :
              <Button type="primary" onClick={() => setIsEditable(false)}>
                Editar
            </Button>}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default PhysicalVerification;